<div class="modal-header">
    <h4 class="modal-title"> {{data.isReferenceDevice ? 'Referans Cihazı' : 'Müşteri Cihazı'}} Ekle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="deviceForm">
        <div class="row" *ngIf="!data.isReferenceDevice">
            <!-- Firma Seçimi -->
            <div class="col-xl-12 col-md-8 col-sm-12 col-12" [ngClass]="{ 'ng-select-disabled': data.companyId }">
                <label for="companyId">Firma</label>
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                    formControlName="companyId"></ng-select>
                <small *ngIf="deviceForm.get('companyId').invalid && deviceForm.get('companyId').touched"
                    class="text-danger">
                    Firma zorunludur.
                </small>
            </div>

            <div class="col-xl-12 col-md-8 col-sm-12 col-12" *ngIf="data.isGetAllProduct">
                <label for="companyId">Hizmetler</label>
                <ng-select [items]="products" bindLabel="name" bindValue="id" formControlName="transactionProductId">
                </ng-select>
                <!-- <small *ngIf="deviceForm.get('transactionProductId').invalid && deviceForm.get('transactionProductId').touched"
                    class="text-danger">
                    Firma zorunludur.
                </small> -->
            </div>

            <div class="col-xl-4 col-md-6 col-sm-12 col-12" *ngIf="false">
                <label for="companyPersonId">Firma Yetkili Kişi</label>
                <div class="form-group">
                    <ng-select [bindValue]="'id'" formControlName="companyPersonId">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' ' +
                            user.lastName}}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>

        <!-- Ürünler -->
        <div formArrayName="createDevicesList">
            <div *ngFor="let product of createDevicesList.controls; let i = index" [formGroupName]="i" class="mt-2">

                <div class="divider">
                    <div class="divider-text">{{i + 1}}. Cihaz</div>
                </div>

                <div class="row">
                    <div class="col-xl-12 col-md-6 col-sm-12 col-12">
                        <label for="seriNo">Cihaz Adı</label>
                        <input type="text" class="form-control" formControlName="deviceName" maxlength="200"
                            (keydown)="preventDelete($event)" />
                    </div>

                    <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                        <label for="kindId">Cihaz Türü</label>
                        <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId">
                            <ng-template ng-optgroup-tmp let-item="item">
                                {{ item.typeName || 'Bilinmeyen Marka' }}
                            </ng-template>
                        </ng-select>
                        <small *ngIf="product.get('kindId')?.invalid && product.get('kindId').touched"
                            class="text-danger">
                            Tür zorunludur.
                        </small>
                    </div>

                    <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                        <label for="brandModelId">Marka</label>
                        <div class="form-group">
                            <ng-select [items]="brands" bindLabel="brandName" bindValue="id" placeholder="Marka seçin"
                                formControlName="brandId" (change)="onBrandChange($event.id)">
                                <ng-template ng-header-tmp>
                                    <button
                                        class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                        (click)="createBrand(i); select.blur(); select.close()">
                                        <i data-feather="plus"></i>
                                        <span class="align-middle ml-25">Marka Ekle</span>
                                    </button>
                                </ng-template>
                            </ng-select>
                            <small *ngIf="product.get('brandModelId')?.invalid && product.get('brandModelId')?.touched"
                                class="text-danger">
                                Marka seçmek zorunludur.
                            </small>
                        </div>
                    </div>

                    <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                        <label for="brandModalId">Model</label>
                        <div class="form-group">
                            <ng-select [items]="filteredModels" bindLabel="modelName" bindValue="id"
                                placeholder="Model seçin" formControlName="brandModelId"
                                [disabled]="!filteredModels.length">
                                <ng-template ng-header-tmp>
                                    <button
                                        class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                        (click)="onCreateBrandModel(i); select.blur(); select.close()">
                                        <i data-feather="plus"></i>
                                        <span class="align-middle ml-25">Model Ekle</span>
                                    </button>
                                </ng-template>
                            </ng-select>
                            <small *ngIf="product.get('brandModalId')?.invalid && product.get('brandModalId')?.touched"
                                class="text-danger">
                                Model seçmek zorunludur.
                            </small>
                        </div>
                    </div>

                    <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                        <label for="seriNo">Seri No</label>
                        <input type="text" class="form-control" formControlName="seriNo" maxlength="50" />
                        <small *ngIf="product.get('seriNo')?.invalid && product.get('seriNo')?.touched"
                            class="text-danger">
                            Seri no zorunludur.
                        </small>
                    </div>

                    <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                        <label for="inventoryNumber">Envanter No</label>
                        <input type="text" class="form-control" formControlName="inventoryNumber" maxlength="20" />
                    </div>

                    <!-- Yer -->
                    <div class="col-xl-2 col-md-6 col-sm-12 col-12" *ngIf="false">
                        <label for="place">Kod</label>
                        <input type="text" class="form-control" formControlName="code" />
                    </div>

                    <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                        <label for="place">Yer</label>
                        <input type="text" class="form-control" formControlName="place" maxlength="25" />
                    </div>

                    <!-- Çözünürlük -->
                    <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                        <label for="resolution">Çözünürlük</label>
                        <input type="text" class="form-control" formControlName="resolution" />
                        <div *ngIf="product.get('resolution')?.invalid && product.get('resolution').touched"
                            class="text-danger">
                            Çözünürlük zorunludur.
                        </div>
                    </div>

                    <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                        <label for="period">Periyot(Ay)</label>
                        <input type="number" class="form-control" formControlName="period" />
                    </div>

                    <div class="col-xl-7 col-md-12 col-sm-12 col-12">
                        <label for="basicTextarea">Açıklama</label>
                        <fieldset class="form-group">
                            <textarea class="form-control" id="basicTextarea" rows="1" placeholder="Cihaz açıklaması"
                                formControlName="description"></textarea>
                        </fieldset>
                    </div>

                    <!-- Referans ID -->
                    <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                        <label for="referenceId">Referans</label>
                        <ng-select [bindValue]="'id'" formControlName="referenceId">
                            <ng-template ng-header-tmp>
                                <button
                                    class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                    (click)="showCreateReferenceDialog(); select.blur(); select.close()">
                                    <i data-feather="plus"></i>
                                    <span class="align-middle ml-25">Referans Ekle</span>
                                </button>
                            </ng-template>
                            <ng-option *ngFor="let reference of references" [value]="reference.id">
                                {{reference.min + reference.unitTypeName + '-' + reference.max
                                +reference.unitTypeName
                                }}</ng-option>
                        </ng-select>
                        <!-- <div *ngIf="product.get('referenceId')?.invalid && product.get('referenceId').touched"
                            class="text-danger">
                            Referans ID zorunludur.
                        </div> -->
                    </div>

                    <ng-template *ngIf="false">
                        <div class="col-xl-2 col-md-6 col-sm-12 col-12">
                            <label for="isDeviceStatus">Cihaz Durumu</label>
                            <select formControlName="isDeviceStatus" class="form-control" id="isDeviceStatus">
                                <option value="true">Aktif</option>
                                <option value="false">Pasif</option>
                            </select>
                            <div *ngIf="product.get('isDeviceStatus')?.invalid && product.get('isDeviceStatus').touched"
                                class="text-danger">
                                Cihaz durumu zorunludur.
                            </div>
                        </div>
                    </ng-template>
                    <!-- Cihaz Durumu -->

                    <!-- Yer -->
                    <div class="col-xl-1 col-md-1 col-sm-12 col-12 mt-2">
                        <button type="button" class="btn btn-icon btn-flat-danger" (click)="removeProduct(i)"
                            rippleEffect>
                            <span [data-feather]="'trash'"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer d-flex" [ngClass]="!data.isReferenceDevice ? 'justify-content-between' : ''">

    <!-- <div class="custom-control custom-control-success custom-checkbox" *ngIf="!data.isReferenceDevice">
        <input type="checkbox" class="custom-control-input" id="colorCheck3" [(ngModel)]="checkboxValue" />
        <label class="custom-control-label" for="colorCheck3">Diğer Bilgileri Gir</label>
    </div> -->
    <div class="row">
        <button type="button" class="btn btn-primary" (click)="addProduct()" *ngIf="!data.isButtonPrivate">Yeni
            Cih.</button>
        <button type="button" class="btn btn-warning ml-1" (click)="copyProduct()" *ngIf="!data.isButtonPrivate"> Cih.
            Kpyla</button>
    </div>
    <div class="row">
        <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
        <button type="button" class="btn btn-success ml-1" [disabled]="!deviceForm.valid"
            (click)="onSumbit()">Kaydet</button>
    </div>
</div>